export const wait = (
  ms: number,
): Promise<(resolve?: (value?: unknown) => void) => NodeJS.Timeout> =>
  new Promise((resolve) => setTimeout(resolve, ms));
